import { useTranslation } from 'next-i18next/pages';

import useCurrentLang from '@/hooks/apps/useCurrentLang';
import { termsFeature } from '@/hooks/shared/termsConfig';
import useGetTerms from '@/hooks/shared/useGetTerms';
import { useMediaQuery } from '@/hooks/shared/useMediaQuery';

import { TermsPageType, isTermsPageType } from '@/utils/isTermsPageType';

import Area from '@/components/apps/layouts/shared/Area';
import TabText from '@/components/shared/ui/tab/TabText';

import theme from '@/styles/theme';

import CkEditorContent from '../../ui/ckEditorContent/CkEditorContent';

/**
 *
 * @returns 개인정보처리방침 / 이용약관 공통 컴포넌트
 */
export default function TermCommonPage({
  content,
  type,
}: {
  content: string;
  type: TermsPageType;
}) {
  const isDesktop = useMediaQuery({
    query: `(min-width: ${theme`screens.lg`})`,
  });

  const { t } = useTranslation('common');

  /** TODO - i18 언어변환 추가 필요 */
  const currentLang = useCurrentLang() ?? 'ko';

  const { replaceContent } = useGetTerms({
    initialContent: content,
    termsType: type,
  });

  // 탭 아이템
  const termsTabItems = Object.keys(termsFeature)
    .filter((key) => isTermsPageType(key))
    .map((key) => ({
      key,
      label: termsFeature[key as TermsPageType].label?.[currentLang],
      value: key,
      href: {
        pathname: `/terms/${key}`,
      },
    }));

  return (
    <>
      <Area>
        {/* 제목 */}
        <h1 className="mb-20 text-[28px] font-bold text-apps-brandGrayBlack">{t('개인정보 보호 및 약관')}</h1>
      </Area>
      <Area className="p-0 lg:px-gutter">
        {/* 탭 */}
        <div>
          <TabText
            replace
            items={termsTabItems}
            hasInnerArea={isDesktop ? false : true}
          />
        </div>
      </Area>
      <Area>
        {/* 본문 */}
        <CkEditorContent content={replaceContent} className="border-none" />
      </Area>
    </>
  );
}


